import React from "react";

const STEPS = [
  { h: "2h", label: "Sourcing & sorting goose down", icon: "🪶" },
  { h: "3h", label: "Cutting & loom-weaving the cotton shell", icon: "🌾" },
  { h: "5h", label: "Hand-stitching all 47 pinch-tuck chambers", icon: "🪡" },
  { h: "2h", label: "Triple-washing & sterilization (anti-allergen)", icon: "💧" },
  { h: "1h", label: "Quality inspection by master craftsman", icon: "🔍" },
  { h: "1h", label: "Luxury packaging & shipping prep", icon: "🎁" },
];

export default function Craftsmanship() {
  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-5xl mx-auto">
          <div>
            <span className="section-pill">⏱ Slow craft, real luxury</span>
            <h2 className="mt-5 text-[34px] sm:text-[42px] md:text-[52px] leading-[1.02] font-black tracking-[-0.02em] text-[#0e0e10]">
              14 hours.
              <br />
              <span className="text-[#8a8a8a]">One pillow.</span>
              <br />
              By hand.
            </h2>
            <p className="mt-5 text-[#5a5a60] text-[15px] md:text-[16px] leading-relaxed">
              Mass-produced pillows take 4 minutes on an assembly line. A Dubai Pillow takes
              <strong className="text-[#0e0e10]"> 14 hours of patient craftsmanship</strong> by trained artisans.
              That's why ours never collapses, never itches, never disappoints — and why we only release
              <strong className="text-[#0e0e10]"> 200 units per week</strong>.
            </p>

            <div className="mt-7 inline-flex items-center gap-3 bg-white border border-black/5 rounded-full px-5 py-3 shadow-sm">
              <span className="w-2 h-2 rounded-full bg-[#ef4444] pulse-dot" />
              <span className="text-[13px] font-semibold text-[#0e0e10]">
                Only 23 units remain this week
              </span>
            </div>
          </div>

          <div className="bg-white rounded-[28px] border border-black/5 p-7 md:p-8 shadow-md">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a] font-bold mb-4">
              Anatomy of 1 Dubai Pillow
            </div>
            <div className="space-y-2.5">
              {STEPS.map((s, i) => (
                <div
                  key={s.label}
                  className="flex items-center gap-3 p-3 bg-[#faf8f4] rounded-2xl"
                >
                  <span className="w-9 h-9 rounded-xl bg-white flex items-center justify-center text-lg shadow-sm flex-shrink-0">
                    {s.icon}
                  </span>
                  <span className="text-[13px] md:text-[14px] text-[#2a2a2e] flex-1">
                    {s.label}
                  </span>
                  <span className="text-[12px] font-bold text-[#0e0e10] bg-[#d8f06b] px-2.5 py-1 rounded-full">
                    {s.h}
                  </span>
                </div>
              ))}
              <div className="mt-4 pt-4 border-t border-[#ececec] flex items-center justify-between">
                <span className="text-[13px] font-semibold text-[#0e0e10]">Total time per pillow</span>
                <span className="font-black text-[20px] text-[#0e0e10]">14 hours</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
